import React from 'react';

export default function EnvironmentMapping() {
    const environments = [
        { id: '501', url: 'https://sit-gateway.optus.com.au' },
        { id: '502', url: 'https://sit2-gateway.optus.com.au' },
        { id: '541', url: 'https://sit4-gateway.optus.com.au'},
        { id: '551', url: 'https://sit5-gateway.optus.com.au'}
    ];

    return (
        <div>
            <div>
                <h2>Environment Mapping</h2>
            </div>
            <div className='environment-mapping'>
                <table>
                    <thead>
                        <tr>
                            <th>Environment</th>
                            <th>Endpoint</th>
                        </tr>       
                    </thead>
                    <tbody>
                    {environments.map(env => (
                        <tr>
                            <td>{env.id}</td>
                            <td>{env.url}</td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

